/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAddonStore } from '../../axios/campaignAddonStore'
import type {
	CampaignAddonStoreError,
	CampaignAddonStorePathParams,
	CampaignAddonStoreRequest,
	CampaignAddonStoreResponse,
} from '../../types/CampaignAddonStore'

export const campaignAddonStoreMutationKey = () => [{ url: '/campaigns/:campaign/addon/:addon' }] as const

export type CampaignAddonStoreMutationKey = ReturnType<typeof campaignAddonStoreMutationKey>

export type CampaignAddonStoreVariables = {
	campaign: CampaignAddonStorePathParams['campaign']
	addon: CampaignAddonStorePathParams['addon']
	data: CampaignAddonStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::store */
export function useCampaignAddonStore<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignAddonStoreResponse,
		AxiosError<CampaignAddonStoreError>,
		CampaignAddonStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignAddonStoreMutationKey(),
		mutationFn: ({ campaign, addon, data }: CampaignAddonStoreVariables) =>
			campaignAddonStore(campaign, addon, data, config).then(res => res.data),
		...options,
	})
}
